import EmptyResult from 'component/EmptyResult'
import NovelBox from 'component/NovelBox'
import { useImmer } from 'use-immer'
import { fetchNovelHistoryList } from 'api'
import { AreaPanelCmsGridWrapper, InfiniteScrollWrapper, PageScrollWrap } from 'commonStyledComponents'

interface NovelState {
  nextPage: number
  isLoading: boolean
  hasMore: boolean
  list: any[]
  page_result: { current: number | null; pageSize: number | null; total: number | null }
  current?: number
}

const Novel = () => {
  const [state, updateState] = useImmer<NovelState>({
    nextPage: 1,
    isLoading: true,
    hasMore: true,
    list: [],

    page_result: { current: null, pageSize: null, total: null },
  })

  const handleFetchNovelList = async () => {
    if (state.current === state.page_result.current || !state.hasMore) return

    const data = {
      current: state.nextPage,
    }

    try {
      const response = await fetchNovelHistoryList(data)
      updateState((draft) => {
        draft.list = draft?.list?.concat(response?.data)
        draft.hasMore = response?.page_result?.total > response?.page_result?.current * response?.page_result?.pageSize
        draft.nextPage = response?.page_result?.current + 1
        draft.page_result = response.page_result

        draft.isLoading = false
      })
    } catch (error) {
      updateState((draft) => {
        draft.isLoading = false
      })
    }
  }

  return !state?.list?.length && !state.isLoading ? (
    <EmptyResult />
  ) : (
    <PageScrollWrap>
      <InfiniteScrollWrapper
        pageStart={0}
        loadMore={handleFetchNovelList}
        hasMore={state?.hasMore}
        // loader={<div className="loader" key={0}>Loading ...</div>}
        useWindow={false}
      >
        {state?.list?.length > 0 && (
          <AreaPanelCmsGridWrapper>
            {state?.list?.map((item, i) => (
              <NovelBox key={i} novelInfo={item} columns={3}>
                {i}
              </NovelBox>
            ))}
          </AreaPanelCmsGridWrapper>
        )}
      </InfiniteScrollWrapper>
    </PageScrollWrap>
  )
}

export default Novel
